import React from 'react'
import {Box, Card, CardActionArea, CardContent, Chip, Typography} from "@mui/material";
import { useHistory } from "react-router-dom";
import useStyles from "../../assets/styles/HomeStyles";
import Icon1 from "../../assets/images/DQProImages/Icon1.png"
import Icon2 from "../../assets/images/DQProImages/Icon2.png"
import Icon3 from "../../assets/images/DQProImages/Home_Icon3.png"
import Icon5 from "../../assets/images/DQProImages/Home_Icon5.png"
import Icon6 from "../../assets/images/DQProImages/Home_Icon6.png"
import Icon7 from "../../assets/images/DQProImages/Home_icon7.png"
import Icon8 from "../../assets/images/DQProImages/icon.png"


const DQProHome= ()=>{
    const classes = useStyles();
    const history = useHistory();

    const cardData = [
        {
            image: Icon1,
            title: (
                <>
                    Get <br /> Onboarded
                </>
            ),
            description: 'How to start and maximize your earnings.',
            disabled: false,
            url: '/dq_pro/onboarded'
        },
        {
            image: Icon2,
            title: (
                <>
                    Your <br/> Product List
                </>
            ),
            description: 'Check the products you can start selling now.',
            disabled: false,
            url: '/dq_pro/products'
        },
        {
            image: Icon3,
            title: (
                <>
                    Sales <br/>Resources
                </>
            ),
            description: 'Find important resources to make your sales easier.',
            disabled: false,
            url: '/dq_pro/sales/resources'
        },
        {
            image: Icon8,
            title: (
                <>
                    Your <br/> Client List
                </>
            ),
            description: 'Add clients and assign product licenses for access.',
            disabled: false,
            url: '/dq_pro/clients/list'
        },
        {
            image: Icon5,
            title: (
                <>
                    Monitor <br/> Impact
                </>
            ),
            description: 'See your program’s impact against global benchmarks.',
            disabled: true,
            url: '/'
        },{
            image: Icon6,
            title: (
                <>
                    PbDQ Pro Certification
                </>
            ),
            description: 'Stand out and become a certified DQ professional.',
            disabled: true,
            url: '/'
        },{
            image: Icon7,
            title: (
                <>
                    Sales <br/> Analytics
                </>
            ),
            description: 'Track your sales and manage your clients.',
            disabled: true,
            url: '/'
        },
    ];

    const handleCardClick = (url, disabled) => {
        if (!disabled) {
            history.push(url);
        }
    };

    return (
        <>
            <Box className={classes.pageContainer} sx={{margin:{xs:'0', sm:'auto'}}}>
                <Typography variant="h3" sx={{ textAlign: "center", marginBottom:{sm:2, xs:1}, marginTop:{xs:'0px', sm:'0px'} }} className={classes.title}>
                    Welcome to Your Powered by DQ Portal
                </Typography>

                {/* First row - cards 1-4 */}
                <Box className={classes.cardsContainer} sx={{flexDirection: { xs: "column", sm: "row" }}}>
                    {cardData.slice(0, 4).map((card, index) => (
                        <Card key={index} className={classes.card} sx={{ backgroundColor: card.disabled ? '#e0e0e0' : '',paddingBottom:'10px',overflow: 'auto',  }}>
                            <CardActionArea
                                onClick={() => handleCardClick(card.url, card.disabled)}
                                disabled={card.disabled}
                            >
                            <CardContent className={classes.cardContent}>
                                    <img src={card.image} className={classes.cardImage} alt="Card Image" />

                                <Typography variant="h5" mt="1" sx={{fontSize:{sm:'1.3rem', md:'1.5rem'},fontWeight:'bold',lineHeight:'1.1', marginTop:'20px', color:'#000000'}}>
                                    {card.title}
                                </Typography>

                                <Typography paragraph sx={{fontSize:'20px',lineHeight:'1.1',padding: {xs:'10px 5px', lg:'10px 30px'},marginTop:'20px',marginLeft:'10px', height: '100px', textAlign: 'center', color:'#000000'}}>
                                    {card.description}
                                </Typography>
                            </CardContent>
                            </CardActionArea>
                        </Card>
                    ))}
                </Box>

                {/* Second row - cards 5-7 */}
                <Box className={classes.cardsContainer} sx={{flexDirection: { xs: "column", sm: "row" }, mt: 2}}>
                    {cardData.slice(4).map((card, index) => (
                        <Card key={index + 4} className={classes.card} sx={{
                            backgroundColor: card.disabled ? '#D9D9D9' : '',
                            border: card.disabled ? 'none' : '1px solid #ff6468ff',
                            position: 'relative',
                            width: {xs:'90%',sm:'20%', md:'22%'},
                            overflow: 'auto',
                            paddingBottom:'10px',
                        }}>
                            <CardActionArea
                                onClick={() => handleCardClick(card.url, card.disabled)}
                                disabled={card.disabled}
                            >
                            {card.disabled && (
                                <Chip
                                    label="Coming Soon"
                                    sx={{
                                        position: 'absolute',
                                        top: '14px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        height: '40px',
                                        width:'75%',
                                        borderRadius:'0px',
                                        backgroundColor: '#000000',
                                        color: 'white',
                                        mb:3,
                                        fontWeight: 'bold',
                                        fontSize:'21px',
                                    }}
                                />
                            )}
                            <CardContent className={classes.cardContent}>
                                    <img src={card.image} className={classes.cardImage} alt="Card Image" />

                                <Typography variant="h5" mt="1" style={{fontWeight:'bold',lineHeight:'1.1', marginTop:'35px',color: card.disabled ? '#ffffff' : '#000000',}}>
                                    {card.title}
                                </Typography>

                                <Typography paragraph sx={{fontSize:{xs:'16px', md:'20px'},lineHeight:'1.1',padding: {xs:'10px 5px', lg:'10px 30px'},marginTop:'20px',marginLeft:'10px', height: '100px', textAlign: 'center', color: card.disabled ? '#ffffff' : '#000000'}}>
                                    {card.description}
                                </Typography>
                            </CardContent>
                            </CardActionArea>
                        </Card>
                    ))}
                </Box>
            </Box>
        </>
    )
}

export default DQProHome;